exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".disclaimer-18040ebf{font-size:10px;line-height:13px;color:#757575}.disclaimer-18040ebf a{color:#212121 !important}.title-2a827a50{font-size:22px;line-height:28px;color:#2a2a2a;margin-bottom:10px;text-align:center;margin-top:30px}.subtitle-e64ddb62{font-size:14px;text-align:center;line-height:16px;color:#757575;padding-bottom:30px;border-bottom:1px solid #e8e8e8}.form-51b17087{margin:30px}.SignupModal-3ab4a59f{display:flex}.left-1342b345{padding:30px;background:#eceed9}.left-1342b345 .title-2a827a50{margin-top:20px;margin-bottom:30px}.left-1342b345,.right-f0982ec0{width:50%}@media (max-width: 889px){.left-1342b345{display:none}.right-f0982ec0{width:100%}.SignupModal-3ab4a59f{display:block}}.logo-5dc15ef7{text-align:center}.feature-cd87afe3{margin-top:30px;color:#2a2a2a}.feature-cd87afe3 svg{display:block;margin-bottom:10px}.featureTitle-d59bae5f{font-weight:500;margin-bottom:5px;color:#282828}\n", ""]);

// Exports
exports.locals = {
	"disclaimer": "disclaimer-18040ebf",
	"title": "title-2a827a50",
	"subtitle": "subtitle-e64ddb62",
	"form": "form-51b17087",
	"SignupModal": "SignupModal-3ab4a59f",
	"left": "left-1342b345",
	"right": "right-f0982ec0",
	"logo": "logo-5dc15ef7",
	"feature": "feature-cd87afe3",
	"featureTitle": "featureTitle-d59bae5f"
};